import {useEffect, useRef, useState} from 'react';
import {copyToClipboard} from '../lib/copy-to-clipboard';

const COPIED_TIMEOUT_S = 1.5;
type UseCopyToClipboardProps = {
  value?: string | number;
  onCopiedLink?: () => void;
  onReset?: () => void;
};

function useCopyToClipboard({value, onCopiedLink, onReset}: UseCopyToClipboardProps) {
  const [isCopied, setIsLinkCopied] = useState(false);
  const timeoutRef = useRef<ReturnType<typeof setTimeout>>();

  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  const copy = () => {
    if (!value) return;

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    copyToClipboard(value);
    setIsLinkCopied(true);
    timeoutRef.current = setTimeout(() => {
      setIsLinkCopied(false);
      onReset?.();
    }, COPIED_TIMEOUT_S * 1000);
    onCopiedLink?.();
  };

  return {isCopied, copy};
}

export {useCopyToClipboard};
